module.exports = __webpack_public_path__ + "static/media/Shedinja_gaussian2.7413d6f5.png";